import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/service/http.service';
import { NgRedux } from '@angular-redux/store';
import { ArgosState } from '../../core/argos-state';
import { FindHttpError } from '../../shared/error/find-http-error';
import { Observable } from 'rxjs/Observable';
import { HttpError } from '../../shared/error/http-error';
import { Subject } from 'rxjs/Subject';
import { Appraisal } from '../../shared/model/appraisal';
import { ReturnReason } from '../model/return-reason';
import { SaveHttpError } from '../../shared/error/save-http-error';
import { Empty } from '../../shared/error/empty';
import { HttpRequestBuilder } from '../../core/http-request-builder';
import { UpdateHttpError } from '../../shared/error/update-http-error';
import * as FileSaver from 'file-saver';
import { PageInfo } from '../../shared/model/page-info';
import { FileService } from '../../shared/service/file.service';

@Injectable()
export class AppraisalService {
  private static APPRAISAL_END_POINT = '/appraisal';

  private SAVE = `${AppraisalService.APPRAISAL_END_POINT}/save`;
  private UPDATE = `${AppraisalService.APPRAISAL_END_POINT}/update`;
  private FIND_APPRAISALS = `${AppraisalService.APPRAISAL_END_POINT}/findByFilter`;
  private FIND_RETURN_REASONS = `${AppraisalService.APPRAISAL_END_POINT}/findReturnReasons`;
  private FIND_BY_ID = `${AppraisalService.APPRAISAL_END_POINT}/find`;
  private FIND_PAGE_INFO = `${AppraisalService.APPRAISAL_END_POINT}/findPageInfo`;
  private DOWNLOAD_APPRAISAL = `${AppraisalService.APPRAISAL_END_POINT}/report`;

  save$: Observable<any>;
  find$: Observable<any>;
  pageInfo$: Observable<PageInfo>;
  error$: Observable<HttpError>;

  private saveSubject: Subject<any>;
  private findSubject: Subject<Array<Appraisal> | Appraisal>;
  private pageInfoSubject: Subject<PageInfo>;
  private errorSubject: Subject<HttpError>;

  constructor(private _httpService: HttpService,
              private _http: HttpRequestBuilder,
              private _fileService: FileService,
              private _ngRedux: NgRedux<ArgosState>) {
    this.saveSubject = new Subject();
    this.save$ = this.saveSubject.asObservable();
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.pageInfoSubject = new Subject();
    this.pageInfo$ = this.pageInfoSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
    this.subscribeFileService();
  }

  save(appraisal, files) {
    this.saveOrUpdate(this._httpService.post(this.SAVE, appraisal, Appraisal, SaveHttpError), files);
  }

  update(appraisal, files) {
    this.saveOrUpdate(this._httpService.put(this.UPDATE, appraisal, Appraisal, UpdateHttpError), files);
  }

  findAppraisals(pageNumber: number, pageSize: number) {
    this._ngRedux.select('appraisalFilter')
      .subscribe(filter => {
        this.findByFilter(filter, pageNumber, pageSize);
        this.findPageInfo(filter, pageSize);
      });
  }

  findById(id: number) {
    this._httpService.get(`${this.FIND_BY_ID}/${id}`, Appraisal, FindHttpError)
      .subscribe(
        appraisal => this.findSubject.next(appraisal),
        error => this.errorSubject.next(error)
      );
  }

  findReturnReasons() {
    this._httpService.get(this.FIND_RETURN_REASONS, ReturnReason, FindHttpError)
      .subscribe(
        returnReasons => this.findSubject.next(returnReasons),
        error => this.errorSubject.next(error)
      );
  }

  downloadAppraisal(appraisal) {
    this._http.post(this.DOWNLOAD_APPRAISAL, appraisal)
      .subscribe(csv => {
        FileSaver.saveAs(new Blob([csv._body], {type: 'text/csv'}),
                        'laudo' + new Date().toDateString() + '.csv');
      },
    error => this.errorSubject.next(new FindHttpError('Erro ao baixar o arquivo!')));
  }

  private saveOrUpdate(observable, files) {
    observable.subscribe(
      appraisalResult => this.saveFiles(appraisalResult, files),
      error => {
        this.errorSubject.next(error);
      }
    );
  }

  private findPageInfo(filter, pageSize) {
    this._httpService.post(`${this.FIND_PAGE_INFO}?pageSize=${pageSize}`, filter, PageInfo, FindHttpError)
      .subscribe(
        pageInfo => this.pageInfoSubject.next(pageInfo),
        error => this.errorSubject.next(error)
      );
  }

  private findByFilter(filter, pageNumber, pageSize) {
    this._httpService.post(`${this.FIND_APPRAISALS}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
                            filter, Array, FindHttpError)
      .subscribe(
        appraisals => this.findSubject.next(appraisals),
        error => this.errorSubject.next(error)
      );
  }

  private saveFiles(appraisal, files) {
    this._fileService.saveAppraisalFiles(files, appraisal);
  }

  private subscribeFileService() {
    this._fileService.save$
      .subscribe(() => this.saveSubject.next());

    this._fileService.error$
      .subscribe((error) => this.errorSubject.next(error));
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/service/appraisal.service.ts